import { useTranslation } from "react-i18next";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import DialogContentWrapper from "../../../common/components/functional/dialogs/DialogContentWrapper";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { TalentStatus } from "../../talents/types/common";
import TalentStatusIcon, {
  StatusTextStyle,
} from "../../../common/components/functional/talentStatus/TalentStatusIcon";

type Props = {
  isOpen: boolean;
  status: TalentStatus;
  onClose: () => void;
  onStatusChange: (status: TalentStatus) => void;
  onConfirm: () => void;
};

const statusOptions: TalentStatus[] = [
  TalentStatus.NEW,
  TalentStatus.INTERVIEW_PENDING,
  TalentStatus.INTERVIEW,
  TalentStatus.ACTIVE,
  TalentStatus.LATER,
  TalentStatus.EMPLOYED_ELSEWHERE,
  TalentStatus.NOT_EMPLOYED,
];

export const TalentStatusDialog = ({
  isOpen,
  status,
  onClose,
  onStatusChange,
  onConfirm,
}: Props) => {
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent) => {
    onStatusChange(event.target.value as TalentStatus);
  };

  return (
    <DialogComponent
      open={isOpen}
      onClose={onClose}
      autoWidth
      sx={{ width: "400px" }}
    >
      <DialogContentWrapper
        title={t("settings:enable")}
        onSave={onConfirm}
        onCancel={onClose}
        customSaveButtonLabel={t("common:save")}
      >
        <Box sx={{ width: "100%", py: 2, px: 2 }}>
          <FormControl fullWidth>
            <InputLabel id="talent-status-select-label">
              {t("talentProfile:statusLabel")}
            </InputLabel>
            <Select
              labelId="talent-status-select-label"
              value={status}
              label={t("talentProfile:statusLabel")}
              onChange={handleChange}
            >
              {statusOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  <TalentStatusIcon
                    status={option}
                    statusTextStyle={StatusTextStyle.SHORT}
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </DialogContentWrapper>
    </DialogComponent>
  );
};
